// extracted by mini-css-extract-plugin
export default {"container":"СalculatorCash_container__yb2Vn","input":"СalculatorCash_input__WvS-I"};